import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PublicIcon from '@mui/icons-material/Public';

/**
 * Tag Deletion Request Dialog Component
 * Dialog for requesting deletion of public tags
 *
 * @param {boolean} open - Whether dialog is open
 * @param {Function} onClose - Handler for closing dialog
 * @param {Object} tag - Tag to request deletion for
 * @param {Function} onConfirm - Handler for confirming deletion request
 */
const TagDeletionRequestDialog = ({
  open,
  onClose,
  tag,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DeleteOutlineIcon />
          Tag-Entfernung vorschlagen
        </Box>
      </DialogTitle>
      <DialogContent>
        {tag && (
          <>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Öffentliches Tag:</strong> Die Entfernung öffentlicher Tags kann von Data Stewards direkt durchgeführt werden.
              </Typography>
            </Alert>

            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Tag-Information:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <PublicIcon fontSize="small" color="primary" />
                <Typography variant="body1" fontWeight="bold">
                  {tag.name}
                </Typography>
              </Box>
              <Typography variant="caption" color="textSecondary" display="block">
                Kategorie: {tag.category}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                Erstellt von: {tag.createdBy}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                Verwendungen: {tag.count}
              </Typography>
            </Paper>

            <Typography variant="body2" color="textSecondary">
              Hinweis: Data Stewards können öffentliche Tags direkt entfernen, ohne dass weitere Bestätigungen erforderlich sind.
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Abbrechen
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          startIcon={<DeleteOutlineIcon />}
        >
          Tag entfernen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TagDeletionRequestDialog;
